import axios from "axios";
import { Button, DataGrid } from "devextreme-react";
import {
  Column,
  ColumnChooser,
  Grouping,
  GroupPanel,
  Item,
  Paging,
  Position,
  Scrolling,
  SearchPanel,
  Sorting,
  Summary,
  Toolbar,
  TotalItem,
} from "devextreme-react/data-grid";
import CustomStore from "devextreme/data/custom_store";
import { useEffect, useState } from "react";

import "./index.css";

export default function SiteVisitTimeGrid(props) {
  const {
    sales,
    siteVisitTimeGridRef,
    siteVisitTimeFullScreen,
    setSiteVisitTimeFullScreen,
  } = props;

  const [dataSource, setDataSource] = useState(null);
  useEffect(() => {
    setDataSource(
      new CustomStore({
        key: "siteNo",
        load: async () => {
          const result = await axios.get(
            `${process.env.REACT_APP_BECCO_API_URL}/api/salesMgmt/sales/siteVisit/time/${sales.contrNo}`
          );

          return result.data;
        },
      })
    );
  }, [sales.contrNo]);

  const headerCellRender = () => {
    return (
      <div>
        Site Information <br /> (Site No.-Site Name-PI Name)
      </div>
    );
  };

  const calculateCellValue = (data) =>
    // `${data.siteNo}-${data.LAB_NAME}-${data.INSPCT_MANAGER_NAME}`;
    `${data.siteNo}-${data.yadmNm}-${data.INSPCT_MANAGER_NAME}`;

  const onCellPrepared = (e) => {
    if (e.rowType == "header") {
      e.cellElement.style.fontWeight = "bold";
      e.cellElement.style.textAlign = "center";
      e.cellElement.style.backgroundColor = "#A9D08E";
    }
  };

  const customizeText = (cellInfo) => {
    return cellInfo.value == 0 ? `` : cellInfo.valueText;
  };

  const onMinMaxIconClick = () => {
    setSiteVisitTimeFullScreen(!siteVisitTimeFullScreen);
  };

  return (
    <DataGrid
      id="siteVisitTimeGrid"
      ref={siteVisitTimeGridRef}
      dataSource={dataSource}
      allowColumnReordering={true}
      allowColumnResizing={true}
      columnResizingMode="widget"
      rowAlternationEnabled={true}
      showBorders={true}
      showRowLines={true}
      showColumnLines={true}
      width={"100%"}
      height={"auto"}
      highlightChanges={true}
      columnAutoWidth={true}
      wordWrapEnabled={true}
      style={{
        maxHeight: "800px",
      }}
      onCellPrepared={onCellPrepared}
    >
      <GroupPanel visible={true} />
      <SearchPanel visible={true} highlightCaseSensitive={true} width={240} />
      <Grouping autoExpandAll={true} />
      <Scrolling
        mode={"virtual"}
        rowRenderingMode={"virtual"}
        columnRenderingMode={"virtual"}
        showScrollbar={"always"}
      />
      <Paging enabled={false} />
      <Sorting mode={"multiple"} />
      <ColumnChooser height={"340px"} enabled={true} mode={"dragAndDrop"}>
        <Position
          my={"right top"}
          at={"right bottom"}
          of={".dx-datagrid-column-chooser-button"}
        />
      </ColumnChooser>

      {/* <Export enabled={true} /> */}

      <Column
        dataField={"siteInfo"}
        // groupIndex/={1}
        dataType={"string"}
        width={400}
        headerCellRender={headerCellRender}
        calculateCellValue={calculateCellValue}
      />
      <Column caption={"Number of Time"}>
        <Column caption={"Pre-Study (PSV)"}>
          <Column
            dataField={"1"}
            caption={"On-Site"}
            dataType={"number"}
            customizeText={customizeText}
          />
          <Column
            dataField={"2"}
            caption={"Remote"}
            dataType={"number"}
            customizeText={customizeText}
          />
        </Column>
        <Column caption={"Initiation (SIV)"}>
          <Column
            dataField={"3"}
            caption={"On-Site"}
            dataType={"number"}
            customizeText={customizeText}
          />
          <Column
            dataField={"4"}
            caption={"Remote"}
            dataType={"number"}
            customizeText={customizeText}
          />
        </Column>
        <Column caption={"Monitoring (SMV)"}>
          <Column
            dataField={"5"}
            caption={"On-Site"}
            dataType={"number"}
            customizeText={customizeText}
          />
          <Column
            dataField={"6"}
            caption={"Remote"}
            dataType={"number"}
            customizeText={customizeText}
          />
        </Column>
        <Column caption={"Close-out (SCV)"}>
          <Column
            dataField={"7"}
            caption={"On-Site"}
            dataType={"number"}
            customizeText={customizeText}
          />
          <Column
            dataField={"8"}
            caption={"Remote"}
            dataType={"number"}
            customizeText={customizeText}
          />
        </Column>
        <Column caption={"Additional (SAV)"}>
          <Column
            dataField={"9"}
            caption={"On-Site"}
            dataType={"number"}
            customizeText={customizeText}
          />
          <Column
            dataField={"10"}
            caption={"Remote"}
            dataType={"number"}
            customizeText={customizeText}
          />
        </Column>
      </Column>
      <Column caption={"Total Count"}>
        <Column
          dataField={"totCT"}
          caption={"Visits"}
          dataType={"number"}
          customizeText={customizeText}
        />
        <Column
          dataField={"rpt"}
          caption={"Report"}
          dataType={"number"}
          customizeText={customizeText}
        />
      </Column>

      <Toolbar>
        <Item name={"columnChooserButton"} />
        <Item location={"after"}>
          <Button
            onClick={onMinMaxIconClick}
            icon={
              siteVisitTimeFullScreen
                ? `fa-solid fa-minimize`
                : `fa-solid fa-maximize`
            }
          />
        </Item>
        <Item name={"searchPanel"} />
      </Toolbar>

      <Summary>
        <TotalItem column={"1"} summaryType={"sum"} displayFormat={"{0}"} />
        <TotalItem column={"2"} summaryType={"sum"} displayFormat={"{0}"} />
        <TotalItem column={"3"} summaryType={"sum"} displayFormat={"{0}"} />
        <TotalItem column={"4"} summaryType={"sum"} displayFormat={"{0}"} />
        <TotalItem column={"5"} summaryType={"sum"} displayFormat={"{0}"} />
        <TotalItem column={"6"} summaryType={"sum"} displayFormat={"{0}"} />
        <TotalItem column={"7"} summaryType={"sum"} displayFormat={"{0}"} />
        <TotalItem column={"8"} summaryType={"sum"} displayFormat={"{0}"} />
        <TotalItem column={"9"} summaryType={"sum"} displayFormat={"{0}"} />
        <TotalItem column={"10"} summaryType={"sum"} displayFormat={"{0}"} />
        <TotalItem column="totCT" summaryType={"sum"} displayFormat={"{0}"} />
        <TotalItem column="rpt" summaryType={"sum"} displayFormat={"{0}"} />
      </Summary>
    </DataGrid>
  );
}
